"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuList = void 0;
var _reactSelect = require("react-select");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var MenuList = (0, _styledComponents.default)(_reactSelect.components.MenuList)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 !important;\n  border-radius: ", ";\n  border: 1px solid ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.radius.sm;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryShade2;
});
exports.MenuList = MenuList;